import { Box, Typography } from "@mui/material";
import { IbssComponent } from "../../Core/BaseComponent/IbssComponent";
import IbssDrawer from "../../Drawer/IbssDrawer";
import { GetAnnouncementDetails } from "./GetAnnouncementDetails";
import IbssSvgIcon from "../../Icons/SvgIcon/IbssSvgIcon";
import BuildingOverviewIcon from "../../Icons/BuildingOverviewIcon";
import CalendarIcon from "../../Icons/CalendarIcon";
import TimeIcon from "../../Icons/TimeIcon";
import { appContext } from "../../../AppContext";
import Link from '@mui/material/Link';
import BackArrowIcon from "../../Icons/BackArrowIcon";
import CrossCircleIcon from "../../Icons/CrossCircleIcon";
import { NodeHelper } from "../../../Common/NodeHelper";
import { DateTime } from "luxon";
import IbssPageHeader from "../../Headings/PageHeading/IbssPageHeader";
import CloseIcon from "../../Icons/CloseIcon";

class IbssCardDetailsDrawer extends IbssComponent<IProps, IState>
{
    private get labels() { return appContext().labels; }
    private nodeHelper = new NodeHelper();
    private announcementHelper = new GetAnnouncementDetails({});

    private handleBackButtonClick = (): void =>
    {
        this.props.onClose();
    }

    private getBuildingName(nodeId: number): string
    {
        return this.nodeHelper.getBuildingByNode(nodeId)?.Name || '';
    }


    public render(): JSX.Element
    {
        const { open, nodeId, availableFrom, imageURI, priority, title, shortMessage, message } = this.props;
        const buildingName = this.getBuildingName(nodeId);
        const formattedDate = availableFrom.toLocaleDateWithWeekDayString();
        const formattedStartTime = availableFrom.toLocaleTimeString();

        const htmlContent = `
        <html>
          <body>${message}</body>
        </html>
      `;

        return (
            <>
                <IbssDrawer anchor="right" open={open} onClose={this.props.onClose}>
                    <Box position="absolute" top={12} right={12} zIndex={99} sx={{ cursor: 'pointer'}}>
                        <IbssSvgIcon onClick={this.props.onClose} fontSize="medium">
                            <CloseIcon />
                        </IbssSvgIcon>
                    </Box>
                    <Box position={"relative"} display={'flex'} justifyContent={'center'} alignItems={'center'} height={250}>
                        <Box
                            component="img"
                            className="news-card-bg-img"
                            src={imageURI}
                            alt="news-img"
                        />
                        <Box
                            position={"absolute"}
                            component="img"
                            sx={{
                                height: 120,
                                width: 120,
                                borderRadius: 2,
                                boxShadow: 3,
                                backgroundColor: ' var(--ui-background-alternate)',
                            }}
                            src={imageURI}
                            alt="news-img"
                        />
                    </Box>
                    <Box position={'relative'} sx={{ height: 'calc(100vh - 338px)', overflow: 'auto', px: 3,pt:3,mt:4 }}>
                        <Typography variant="h6" color="error">
                            {this.announcementHelper.getNotificationStatus(priority)}
                        </Typography>
                        <IbssPageHeader
                            title={title}
                            description={shortMessage}
                        />

                        <Box display="flex" alignItems="center" marginTop={2} gap={2} className={'ui-text-light'}>
                            <Box display={'flex'} gap={1}>
                                <IbssSvgIcon fontSize="small" >
                                    <BuildingOverviewIcon />
                                </IbssSvgIcon>
                                <Typography variant="body2" sx={{ marginRight: 1 }}>
                                    {buildingName}
                                </Typography>
                            </Box>

                            <Box display={'flex'} gap={1} color="textSecondary">
                                <IbssSvgIcon fontSize="small" >
                                    <CalendarIcon />
                                </IbssSvgIcon>
                                <Typography variant="body2" sx={{ marginRight: 1 }}>
                                    {formattedDate}
                                </Typography>
                            </Box>

                            <Box display={'flex'} gap={0.5} sx={{ marginTop: '1px' }}>
                                <IbssSvgIcon fontSize="medium">
                                    <TimeIcon />
                                </IbssSvgIcon>
                                <Typography variant="body2" sx={{ marginRight: 1, marginTop: '1px' }}>
                                    {formattedStartTime}
                                </Typography>
                            </Box>
                        </Box>
                        <iframe
                            srcDoc={htmlContent}
                            style={{ width: "100%",maxHeight:'calc(100vh - 520px)',minHeight:'150px',height:'100%',border: "none" }}
                        />
                    </Box>
                    <Box py={2} px={5}>
                        <Link href="#" variant="body2" color="secondary" sx={{ textDecoration: 'none' }} onClick={this.handleBackButtonClick} className={'ui-text-light'}>
                            <Box display={'flex'} alignItems={'center'} gap={1}>
                                <IbssSvgIcon fontSize="small">
                                    <BackArrowIcon />
                                </IbssSvgIcon>
                                {this.labels.funcBackToNotifications_S}
                            </Box>
                        </Link>
                    </Box>
                </IbssDrawer>
            </>
        )
    }
}

export interface IProps
{
    open: boolean;
    onClose: () => void;
    nodeId: number,
    availableFrom: DateTime,
    imageURI: string,
    priority: number,
    title: string,
    shortMessage: string,
    message: string
}

export interface IState
{

}

export default IbssCardDetailsDrawer;